<template>
  <div>
    <div class="columns is-vcentered" v-if="small">
      <div class="column tw-pt-0">
        <div
          class="card tw-shadow-none tw-border-b tw-border-solid tw-border-gray-100"
        >
          <div class="card-content tw-px-0 tw-pt-0">
            <router-link
              :to="{
                name: redirectTo,
                params: { slug: blog.slug }
              }"
              class="has-text-weight-bold tw-text-black hover:tw-text-primary"
            >
              <span class="is-size-4 tw-leading-snug">
                {{ blog.title }}
              </span>
            </router-link>
            <p class="content is-size-6 tw-mt-1 tw-text-black-light">
              {{ blog.subtitle }}
            </p>
            <div class="media tw-mt-5">
              <div class="media-left">
                <figure class="image is-32x32">
                  <img
                    class="is-elongated"
                    v-lazy="blog.created_by.avatar_url"
                    alt="Placeholder image"
                  />
                </figure>
              </div>
              <div class="media-content">
                <p v-if="blog.created_by" class="title is-6">
                  <span class="tw-text-grey-light">Posted by </span>
                  <span class="tw-text-black">{{
                    blog.created_by.full_name
                  }}</span>
                </p>
                <p class="subtitle is-6 tw-text-grey-lighter">
                  <small>{{ blog.createdAtFromNow }}</small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="blog.cover" class="column is-one-third">
        <router-link
          :to="{
            name: redirectTo,
            params: { slug: blog.slug }
          }"
        >
          <figure class="image is-1by1">
            <img
              class="tw-rounded tw-object-cover"
              v-lazy="blog.cover.url"
              alt="Blog cover"
            />
          </figure>
        </router-link>
      </div>
    </div>
    <div v-else class="card card-blog tw-shadow-none tw-mb-10">
      <div v-if="blog.cover" class="card-image">
        <router-link :to="{ name: redirectTo, params: { slug: blog.slug } }">
          <figure class="image is-5by3">
            <img v-lazy="blog.cover.url" alt="Training Blog Post Image" />
          </figure>
        </router-link>
      </div>
      <div class="card-content tw-px-0">
        <router-link
          :to="{ name: redirectTo, params: { slug: blog.slug } }"
          class="has-text-weight-bold"
        >
          <span class="tw-text-black hover:tw-text-primary">
            {{ blog.title }}
          </span>
        </router-link>
        <div class="media tw-mt-5">
          <div class="media-left">
            <figure class="image is-32x32">
              <img
                class="is-elongated"
                v-lazy="blog.created_by.avatar_url"
                alt="Placeholder image"
              />
            </figure>
          </div>
          <div class="media-content">
            <p v-if="blog.created_by" class="title is-6">
              <span class="tw-text-grey-light">Posted by </span>
              <span class="tw-text-black">{{ blog.created_by.full_name }}</span>
            </p>
            <p class="tw-text-grey-lighter subtitle is-6">
              <small>{{ blog.createdAtFromNow }}</small>
            </p>
          </div>
        </div>
        <p class="is-size-6 tw-text-black-light">
          {{ blog.subtitle }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    blog: {
      type: Object,
      default() {
        return null
      }
    },
    redirectTo: {
      type: String
    },
    small: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.card-blog {
  .card-image {
    box-shadow: 0 9px 24px 0 rgba(46, 72, 77, 0.15);
  }
}
</style>
